import React, { useEffect, useRef, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, Input, Label } from 'reactstrap'

type ManualInsertModalProps = {
  isOpen: boolean
  toggle: () => void
  loading?: boolean
  onConfirm: (codice: string, qta: number) => Promise<void> | void
}

export default function ManualInsertModal({
  isOpen,
  toggle,
  loading = false,
  onConfirm,
}: ManualInsertModalProps) {
  const [codice, setCodice] = useState('')
  const [qta, setQta] = useState<number>(1)
  const codiceRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => codiceRef.current?.focus(), 100)
    } else {
      setCodice('')
      setQta(1)
    }
  }, [isOpen])

  const handleConfirm = async () => {
    const c = codice.trim()
    const n = Number(qta)

    if (!c) return
    if (!Number.isFinite(n) || n < 1) return

    await onConfirm(c, n)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Inserisci manualmente</ModalHeader>

      <ModalBody>
        <div className="mb-3">
          <Label className="mb-1" for="manualCodice">Codice</Label>
          <Input
            id="manualCodice"
            innerRef={codiceRef as any}
            value={codice}
            onChange={e => setCodice(e.target.value)}
            placeholder="Inserisci codice..."
            autoComplete="off"
            disabled={loading}
          />
        </div>

        <div>
          <Label className="mb-1" for="manualQta">Quantità</Label>
          <Input
            id="manualQta"
            type="text"
            min={1}
            step={1}
            value={qta}
            onChange={e => setQta(Number(e.target.value))}
            disabled={loading}
          />
          <small className="text-muted">Verrà eseguita la verifica per {qta || 1} unità.</small>
        </div>
      </ModalBody>

      <ModalFooter className="d-flex justify-content-between">
        <Button color="light" style={{ color: 'black' }} onClick={toggle} disabled={loading}>
          Annulla
        </Button>
        <Button color="primary" onClick={handleConfirm} disabled={loading || !codice.trim() || qta < 1}>
          {loading ? <Spinner size="sm" /> : 'Verifica'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
